/**
* @name: LayoutContent
* @author: weiyong
* @date: 2022-10-01 08:42
* @description：LayoutContent
* @update: 2022-10-01 08:42
*/
<template>
  <div class="LayoutContent">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "LayoutContent"
}
</script>

<script lang="ts" setup>

</script>

<style type="text/css" lang="less">
.LayoutContent{
  width: 100%;
  height: 100%;
  display: flex;
}
</style>
